export default {
  page_header: {
    home_button_click: "page_header:home_button_click",
    spotlight_search_button_click: "page_header:spotlight_search_button_click",
    team_switcher_button_click: "page_header:team_switcher_button_click"
  },
  app_menu: {
    home_menu_item_click: "app_menu:home_menu_item_click",
    search_menu_item_click: "app_menu:search_menu_item_click",
    experiments_menu_item_click: "app_menu:experiments_menu_item_click",
    datasets_menu_item_click: "app_menu:datasets_menu_item_click",
    configure_new_experiment_menu_item_click: "app_menu:configure_new_experiment_menu_item_click",
    upload_dataset_menu_item_click: "app_menu:upload_dataset_menu_item_click",
    profile_menu_item_click: "app_menu:profile_menu_item_click",
    organization_menu_item_click: "app_menu:organization_menu_item_click",
    settings_menu_item_click: "app_menu:settings_menu_item_click",
    atinary_menu_item_click: "app_menu:atinary_menu_item_click"
  },
  spotlight_search: {
    toggle_by_hotkey: "spotlight_search:toggle_by_hotkey",
    home_click: "spotlight_search:home_click",
    new_experiment_click: "spotlight_search:new_experiment_click",
    upload_dataset_click: "spotlight_search:upload_dataset_click",
    favorite_experiment_click: "spotlight_search:favorite_experiment_click",
    recent_experiment_click: "spotlight_search:recent_experiment_click",
    other_experiment_click: "spotlight_search:other_experiment_click",
    search_experiment_click: "spotlight_search:search_experiment_click",
    search_dataset_click: "spotlight_search:search_dataset_click"
  },
  team_switcher: {
    team_click: "team_switcher:team_click"
  },
  dashboard: {
    team_activity_experiment_click: "dashboard:team_activity_experiment_click",
    team_activity_dataset_click: "dashboard:team_activity_dataset_click",
    configure_new_experiment_button_click: "dashboard:configure_new_experiment_button_click",
    upload_dataset_click: "dashboard:upload_dataset_click",
    agent_chat_input_submit_click: "dashboard:agent_chat_input_submit_click",
    agent_file_upload_click: "dashboard:agent_file_upload_click"
  },
  favorite_experiment_list: {
    experiment_click: "favorite_experiment_list:experiment_click"
  },
  recent_experiments_list: {
    experiment_click: "recent_experiments_list:experiment_click"
  },
  dataset_drop_zone: {
    file_upload: "dataset_drop_zone:file_upload"
  },
  upload_dataset_modal: {
    dataset_create: "upload_dataset_modal:dataset_create_button_click"
  },
  experiment_measurements: {
    recommendations_download: "experiment_measurements:recommendations_download_button_click",
    results_upload: "experiment_measurements:results_upload_button_click",
    submit_results: "experiment_measurements:submit_results_button_click"
  },
  predictions: {
    query: "predictions:query_button_click",
    explanation_chart_query: "predictions:query_explanation_chart_button_click"
  },
  experiment_details: {
    use_as_template: "experiment_details:use_as_template_button_click",
    deep_research: {
      toggle_session_details_click: "experiment_details_deep_research:toggle_session_details_click",
      cancel_session_click: "experiment_details_deep_research:cancel_session_click",
      report_click: "experiment_details_deep_research:report_click",
      download_report_click: "experiment_details_deep_research:download_report_click",
      report_back_button_click: "experiment_details_deep_research:report_back_button_click"
    }
  },
  experiment_favorite_button: {
    click: "experiment_favorite_button:click"
  },
  experiment_list: {
    use_as_template: "experiment_list:use_as_template_button_click",
    create_experiment_button_click: "experiment_list:create_experiment_button_click",
    experiment_click: "experiment_list:experiment_click",
    filter_change: "experiment_list:filter_change"
  },
  dataset_list: {
    use_as_input_dataset: "dataset_list:use_as_input_dataset_button_click",
    dataset_click: "dataset_list:dataset_click",
    generated_by_experiment_click: "dataset_list:generated_by_experiment_click",
    used_by_experiment_click: "dataset_list:used_by_experiment_click"
  },
  experiment_draft: {
    experiment_create: "experiment_draft:experiment_create_button_click"
  },
  experiment_agent: {
    open_click: "experiment_agent:open_click",
    agent_chat_input_submit: "experiment_agent:agent_chat_input_submit",
    minimize_click: "experiment_agent:minimize_click",
    clear_conversation_confirmed_click: "experiment_agent:clear_conversation_confirmed_click",
    clear_conversation_cancelled_click: "experiment_agent:clear_conversation_cancelled_click",
    sidebar_resize_drag: "experiment_agent:sidebar_resize_drag",
    toggle_chat_mode_click: "experiment_agent:toggle_chat_mode_click",
    session_rating_click: "experiment_agent:session_rating_click",
    file_upload_click: "experiment_agent:file_upload_click",
    file_drop: "experiment_agent:file_drop",
    attach_deep_research_report_click: "experiment_agent:attach_deep_research_report_click",
    deep_research_chat_status_cancel_click: "experiment_agent:deep_research_chat_status_cancel_click",
    deep_research_chat_status_completed_click_to_open:
      "experiment_agent:deep_research_chat_status_completed_click_to_open"
  },
  attach_deep_research_modal: {
    attach_click: "attach_deep_research_modal:attach_click",
    close_click: "attach_deep_research_modal:close_click",
    search_input_focus: "attach_deep_research_modal:search_input_focus",
    search_input_change: "attach_deep_research_modal:search_input_change"
  },
  historical_data_mapping: {
    save_blocked_output_dataset_constant: "historical_data_mapping:save_blocked_output_dataset_constant"
  },
  // Every chart reports the same actions: `view` once per mount, when it first scrolls into the
  // viewport; `expand` and `collapse` when its section is toggled; `export` when an image export is
  // confirmed; and `interaction` when the user works the chart itself (clicks a marker or legend
  // entry, brushes an axis, changes an axis or objective), with a `control` property naming which.
  landscape_chart: {
    view: "landscape_chart:view",
    expand: "landscape_chart:expand",
    collapse: "landscape_chart:collapse",
    export: "landscape_chart:export",
    interaction: "landscape_chart:interaction"
  },
  progress_prediction_chart: {
    view: "progress_prediction_chart:view",
    expand: "progress_prediction_chart:expand",
    collapse: "progress_prediction_chart:collapse",
    export: "progress_prediction_chart:export",
    interaction: "progress_prediction_chart:interaction"
  },
  parallel_coordinates_chart: {
    view: "parallel_coordinates_chart:view",
    expand: "parallel_coordinates_chart:expand",
    collapse: "parallel_coordinates_chart:collapse",
    export: "parallel_coordinates_chart:export",
    interaction: "parallel_coordinates_chart:interaction"
  },
  prediction_explanation_chart: {
    view: "prediction_explanation_chart:view",
    expand: "prediction_explanation_chart:expand",
    collapse: "prediction_explanation_chart:collapse",
    export: "prediction_explanation_chart:export",
    interaction: "prediction_explanation_chart:interaction"
  },
  prediction_profiler_chart: {
    view: "prediction_profiler_chart:view",
    expand: "prediction_profiler_chart:expand",
    collapse: "prediction_profiler_chart:collapse",
    interaction: "prediction_profiler_chart:interaction"
  },
  settings: {
    theme_change: "settings:theme_change"
  }
};
